// extracted by mini-css-extract-plugin
export default {"Wrapper":"Contracts_Wrapper__VGNp8"};